import { log } from "@dustin-web/microsite-config/src/logger";
import type { EventDispatcher, EventDispatcherResponse, LogEvent } from '@optimizely/react-sdk'

export const createOptimizelyEventDispatcher = (hasAnalyticsConsent: boolean): EventDispatcher => ({
  dispatchEvent: (event: LogEvent): Promise<EventDispatcherResponse> => {
    if (!hasAnalyticsConsent) {
      return Promise.resolve({})
    }

    return fetch(event.url, {
      method: event.httpVerb,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event.params),
    })
      .then(response => ({ statusCode: response.status }))
      .catch(_ => {
        log.warn('Failed to send Optimizely event')
        return {}
      })
  },
})
